import { nextTick, onMounted, onUnmounted, ref, watch } from "vue";
import { useRoute } from "vue-router";
import { debounce } from "lodash";

// 计算表格高度
export default function useTableHeight(offset = 0) {
    const tableHeight = ref(0);
    const ready = ref(false);
    const route = useRoute();
    function calculateHeight() {
        // 列表页
        const listPageDom = document.querySelector(".layout-main-container .list-page");
        if (!listPageDom) {
            return;
        }
        const listPageHeight = listPageDom?.getBoundingClientRect().height || 0;

        // 页码的高度
        const paginationDom = document.querySelector(".list-page .zh-pagination") as HTMLElement;
        const paginationHeight = paginationDom?.getBoundingClientRect().height + 40 || 74;

        // table Dom
        const tableBodyDom = document.querySelector(".list-page .zh-table .table-body-container .el-table") as HTMLElement;

        if (tableBodyDom) {
            // table 上面内容的高度
            const tableTopHeight = tableBodyDom.getBoundingClientRect().y - listPageDom.getBoundingClientRect().y;
            tableHeight.value = listPageHeight - tableTopHeight - paginationHeight - 10 - offset;
            tableBodyDom.style.maxHeight = `${tableHeight.value}px`;
            const scrollDom = tableBodyDom.querySelector(".el-table__body-wrapper .el-scrollbar__wrap") as HTMLElement;
            if (scrollDom) {
                scrollDom.style.maxHeight = `${tableHeight.value - 40}px`;
            }
            ready.value = true; // 计算完成后标记就绪
        }
        // console.log("tableHeight=", tableHeight.value);
    }

    const calculateHeightDebounce = debounce(calculateHeight, 100);
    onMounted(() => {
        nextTick(() => {
            calculateHeight();
            window.addEventListener("resize", calculateHeightDebounce);
        });
    });

    // 监听路由变化
    const stopWatch = watch(
        () => route.path,
        () => nextTick(calculateHeight),
        { flush: "post" }
    );
    onUnmounted(() => {
        window.removeEventListener("resize", calculateHeightDebounce);
        stopWatch();
    });

    // 暴露手动触发计算的函数
    const refreshHeight = () => nextTick(calculateHeight);

    return { tableHeight, ready, refreshHeight };
}
